module.exports = __webpack_public_path__ + "img/葛珂.4ed6a122.jpg";